import { useCallback } from 'react';
import { FORM_MODES } from 'config/formModes';
import { withFormDataProvider } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useModal } from 'modules/taboola-common-frontend-modules/modals';
import { DuplicateLandingPageModal } from '../components/Modals/DuplicateLandingPageModal';

// Hook for modal management (used by components that want to open the modal)
export const useDuplicateLandingPageModal = () => {
    const { open: openModal } = useModal();

    const openDuplicateModal = useCallback(
        async ({ originalTitle, landingPageId, status }) => {
            const suggestedTitle = `${originalTitle} - Copy`;

            // Create the modal component with initial data in defaultValuesConfig
            const DuplicateLandingPageModalWithFormData = withFormDataProvider(DuplicateLandingPageModal, {
                formContainerId: 'duplicate-landing-page-modal',
                isNetworkOwnerAllowed: true,
                mode: FORM_MODES.DUPLICATE,
                defaultValuesConfig: {
                    title: suggestedTitle,
                },
            });

            const result = await openModal({
                title: (
                    <FormattedMessage
                        id="landing.pages.duplicate.modal.title"
                        defaultMessage="Duplicate Advertorial"
                        tagName="h2"
                    />
                ),
                contentRenderer: DuplicateLandingPageModalWithFormData,
                hasCloseButton: true,
                initialData: {
                    landingPageId,
                    status,
                },
            });

            return result;
        },
        [openModal]
    );

    return { openDuplicateModal };
};
